var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.5@core-js/modules/_core.js
// module id = 25
// module chunks = 0